import {
  DerivedTextConfig,
  DerivedTextFormulaKey,
} from 'src/types/configuration';

export const DERIVED_TEXT_FORMULAS: Record<
  DerivedTextFormulaKey,
  (sourceValue: number) => number
> = {
  bedroom_max_occupancy: (numBedrooms) => Math.min(2 * numBedrooms + 2, 12),
};

// Returns the template with '{{result}}' filled in, or null when the source
// question hasn't been answered with a valid number yet.
export const resolveDerivedText = (
  config: DerivedTextConfig,
  formValues: Record<string, unknown> | undefined,
  sourceKey: string
): string | null => {
  const sourceValue = Number(formValues?.[sourceKey]);
  if (
    !formValues ||
    formValues[sourceKey] === undefined ||
    Number.isNaN(sourceValue)
  ) {
    return null;
  }

  const result = DERIVED_TEXT_FORMULAS[config.formula](sourceValue);
  return config.template.replace('{{result}}', String(result));
};
